"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIndicator = DropdownIndicator;
exports.ClearIndicator = ClearIndicator;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _icons = require("../constants/icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function DropdownIndicator(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactSelect.components.DropdownIndicator, props,
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: _icons.icons.chevronDown
    }))
  );
}

function ClearIndicator(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactSelect.components.ClearIndicator, props,
    /*#__PURE__*/
    _react["default"].createElement("span", {
      className: _icons.icons.x
    }))
  );
}